<template>
  <div
    v-if="filteredMessages.length"
    class="delivery-messaging"
  >
    <swiper
      class="delivery-messaging__carousel"
      :pagination="pagination"
      :modules="modules"
      :autoplay="filteredMessages.length > 1
        ? {delay: 2000, disableOnInteraction: false}
        : 'false'
      "
      :loop="true"
      :effect="'fade'"
    >
      <swiper-slide
        v-for="(message, index) in filteredMessages"
        :key="`delivery-message-${index}`"
        class="delivery-messaging__slide"
      >
        <img
          v-if="message.icon"
          class="delivery-messaging__image"
          :src="message.icon"
          alt=""
        >

        <div
          class="
            delivery-messaging__text-small
            delivery-messaging__mobile-text
          "
          v-html="message.mobileText"
        />

        <div
          class="
            delivery-messaging__text-large
            delivery-messaging__desktop-text
          "
          v-html="message.desktopText"
        />

        <div
          class="
            delivery-messaging__text-small
            delivery-messaging__text-end
            delivery-messaging__desktop-text
          "
          v-html="message.desktopTextAdditional"
        />
      </swiper-slide>
    </swiper>

    <div class="swiper-pagination delivery-messaging__pagination" />
  </div>
</template>

<script>

/**
 * Vue: Delivery messaging (delivery-messaging)
 * -----------------------------------------------------------------------------
 * Carousel including an icon, message and link.
 *
 */
import { Navigation, A11y, Pagination, Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  name: 'DeliveryMessaging',

  components: {
    Swiper,
    SwiperSlide,
  },

  setup() {
    return {
      modules: [
        Navigation, A11y, Pagination, Autoplay, EffectFade,
      ],
      pagination: {
        el: '.delivery-messaging__pagination',
        clickable: true,
      },
    }
  },

  computed: {

    /**
     * Delivery messages
     * @returns {Array}
     */
    messages() {
      return [
        {
          icon: window.cnvs.deliveryMessage.icon1,
          mobileText: window.cnvs.deliveryMessage.mobileText1,
          desktopText: window.cnvs.deliveryMessage.desktopText1,
          desktopTextAdditional: window.cnvs.deliveryMessage.desktopTextAdditional1,
        },
        {
          icon: window.cnvs.deliveryMessage.icon2,
          mobileText: window.cnvs.deliveryMessage.mobileText2,
          desktopText: window.cnvs.deliveryMessage.desktopText2,
          desktopTextAdditional: window.cnvs.deliveryMessage.desktopTextAdditional2,
        },
        {
          icon: window.cnvs.deliveryMessage.icon3,
          mobileText: window.cnvs.deliveryMessage.mobileText3,
          desktopText: window.cnvs.deliveryMessage.desktopText3,
          desktopTextAdditional: window.cnvs.deliveryMessage.desktopTextAdditional3,
        },
      ]
    },

    /**
     * Filtered messages
     * @returns {Array}
     */
    filteredMessages() {
      return this.messages.filter((message) => {
        return message.mobileText && message.desktopText
      })
    },
  },
}
</script>

<style lang="scss">
@import './delivery-messaging';
</style>
